import { removeCustomer } from 'helpers/customer';
import useBreakpoint from 'hooks/useBreakpoint';
import { useTranslation } from 'react-i18next';

const AccountLogoutButton = () => {
	const { t } = useTranslation();
	const { isMobile, isTablet } = useBreakpoint();
	const isMobileView = isMobile || isTablet;

	const handleLogout = () => {
		removeCustomer();
		window.location = '/';
	};

	// Только для мобильной версии
	if (!isMobileView) {
		return null;
	}

	return (
		<div className="account-logout-wrapper">
		<button type="button" className="account-menu-logout" onClick={handleLogout}>
			{t('accountMenu.logout')}
		</button>
		</div>
	);
};

export default AccountLogoutButton;



